import './recipe-highlight-teaser.scss';

import Swiper from 'swiper';
import { A11y, EffectCards, Navigation, Pagination } from 'swiper/modules';

class RecipeHighlightTeaser {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-recipe-highlight-teaser',
            sliderAttr: 'slider',
            slideAttr: 'slide'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$recipeHighlightTeaser = $element;
        this.$recipeHighlightTeaserContainer = this.$recipeHighlightTeaser.querySelector(`[${this.settings.initAttr}="${this.settings.sliderAttr}"]`);
        this.$recipeHighlightTeaserSlides = this.$recipeHighlightTeaser.querySelectorAll(`[${this.settings.initAttr}="${this.settings.slideAttr}"]`);
        this.recipeHighlightSlider = null;

        if (this.$recipeHighlightTeaserContainer && this.$recipeHighlightTeaserSlides.length > 1) {
            this.initialize();
        }
    }

    initialize () {
        if (!window.mediaMatchHandler[1024].matches) {
            this.initMobileSlider();
        } else {
            this.initDesktopSlider();
        }

        this.setEvents();
    }

    setEvents () {
        window.mediaMatchHandler[1024].addEventListener('change', (match) => {
            if (!match.matches) {
                this.destroySlider();
                this.initMobileSlider();
            } else {
                this.destroySlider();
                this.initDesktopSlider();
            }
        });
    }

    initMobileSlider () {
        this.recipeHighlightSlider = new Swiper(this.$recipeHighlightTeaserContainer, {
            modules: [EffectCards, Navigation, Pagination, A11y],
            speed: 500,
            effect: 'cards',
            cardsEffect: {
                rotate: true,
                perSlideRotate: 2,
                perSlideOffset: 3,
                slideShadows: false
            },
            a11y: {
                prevSlideMessage: 'Vorheriger Slide',
                nextSlideMessage: 'Nächster Slide'
            },
            slidesPerView: 'auto',
            centeredSlides: true,
            centeredSlidesBounds: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next'
            },
            on: {
                transitionEnd: (swiper) => {
                    const activeSlideIndex = swiper.activeIndex;
                    const $activeSlide = swiper.slides[activeSlideIndex];
                    const activeTranslateX = swiper.translate;
                    const transformStyle = 'translate3d(' + activeTranslateX + 'px, 0, 0)';
                    $activeSlide.style.transform = transformStyle;
                }
            }
        });
    }

    initDesktopSlider () {
        this.recipeHighlightSlider = new Swiper(this.$recipeHighlightTeaserContainer, {
            modules: [Navigation, Pagination],
            speed: 500,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            slidesPerView: 'auto',
            centeredSlides: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next'
            }
        });
    }

    destroySlider () {
        if (this.recipeHighlightSlider !== null) {
            this.recipeHighlightSlider.destroy(true, true);
            this.recipeHighlightSlider = null;
        }
    }
}

export { RecipeHighlightTeaser };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$recipeHighlightTeaser = $context.querySelectorAll('[data-recipe-highlight-teaser="root"]');
        for (let i = 0; i < $$recipeHighlightTeaser.length; i++) {
            const $recipeHighlightTeaser = $$recipeHighlightTeaser[i];

            $recipeHighlightTeaser.API = new RecipeHighlightTeaser($recipeHighlightTeaser);
        }
    }
});
